import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseurl =
    process.env.REACT_APP_BASE_URL ||
    "http://localhost:8000/api";

const handleError = (error) => {
    return error?.response?.data || {
        detail: error?.message || "Request failed.",
    };
};

const getToken = (getState) =>
  getState?.().auth?.access_token || localStorage.getItem("access_token");

const getHeaders = (token) => ({
  "Content-Type": "application/json",
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});


export const listQuizTopics = createAsyncThunk(
    "quiz/listQuizTopics",
    async (payload, { rejectWithValue, getState }) => {
        try {
            const token = getToken(getState);
            const response = await axios.get(
                `${baseurl}/quiz/topics/`,
                {
                    headers: getHeaders(token),
                }
            );
            return response.data;
        }
        catch (error) {
            return rejectWithValue(handleError(error));
        }
    }
);

export const startQuiz = createAsyncThunk(
    "quiz/startQuiz",
    async (payload, { rejectWithValue, getState }) => {
        try {
            const token = getToken(getState);

            const response = await axios.post(
                `${baseurl}/quiz/start/`,
                payload,
                {
                    headers: getHeaders(token),
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(handleError(error));
        }
    }
);



export const getQuizQuestions = createAsyncThunk(
  "quiz/getQuestions",
  async ({ session_id, question_number }, { rejectWithValue, getState }) => {
    try {
      const token = getToken(getState);

      const response = await axios.get(
        `${baseurl}/quiz/${session_id}/question/${question_number}/`,
        {
          headers: getHeaders(token),
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(handleError(error));
    }
  }
);

export const getQuizHistory = createAsyncThunk(
  "quiz/getHistory",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const token = getToken(getState);

      const response = await axios.get(`${baseurl}/quiz/history/`, {
        headers: getHeaders(token),
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(handleError(error));
    }
  }
);

export const getSessionResult = createAsyncThunk(
  "quiz/getSessionResult",
  async ({ session_id }, { rejectWithValue, getState }) => {
    try {
      const token = getToken(getState);

      const response = await axios.get(`${baseurl}/quiz/${session_id}/result/`, {
        headers: getHeaders(token),
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(handleError(error));
    }
  }
);

export const submitAnswer = createAsyncThunk(
  "quiz/submitAnswer",
  async ({ session_id, question_number, selected_option }, { rejectWithValue, getState }) => {
    try {
      const token = getToken(getState);

      const response = await axios.post(
        `${baseurl}/quiz/${session_id}/question/${question_number}/answer/`,
        { selected_option },
        {
          headers: getHeaders(token),
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(handleError(error));
    }
  }
);


export const startMocKExamSession = createAsyncThunk(
  "quiz/startMockExamSession",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const token = getToken(getState);

      const response = await axios.post(
        `${baseurl}/quiz/start/`,
        payload,
        {
          headers: getHeaders(token),
        }
      );

            return response.data;
    } catch (error) {
      return rejectWithValue(handleError(error));
    }
  }
);

export const getOpenQuizSessions = createAsyncThunk(
  "quiz/getOpenQuizSessions",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getToken(getState);
      const response = await axios.get(`${baseurl}/quiz/open/`, {
        headers: getHeaders(token),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(handleError(error));
    }
  }
);

export const resumeQuizSession = createAsyncThunk(
  "quiz/resumeQuizSession",
  async (sessionId, { rejectWithValue, getState }) => {
    try {
      const token = getToken(getState);
      const response = await axios.post(
        `${baseurl}/quiz/${sessionId}/resume/`,
        {},
        { headers: getHeaders(token) }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(handleError(error));
    }
  }
);


export const loadModuleAssessment = createAsyncThunk(
  "quiz/loadModuleAssessment",
  async (domainId, { rejectWithValue, getState }) => {
    try {
      const token = getToken(getState);
      const response = await axios.get(
        `${baseurl}/courses/domains/${domainId}/assessment/`,
        { headers: getHeaders(token) }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(handleError(error));
    }
  }
);

export const quickQuiz = createAsyncThunk(
  "quiz/quickQuiz",
  async (chapterId, { rejectWithValue, getState }) => {
    try {
      const token = getToken(getState);
      const url = `${baseurl}/courses/chapters/${chapterId}/quick-quiz/`;
            const response = await axios.get(
        url,
        {
          headers: getHeaders(token),
        }
      );
            return response.data;
    } catch (error) {
            return rejectWithValue(handleError(error));
    }
  }
);

export const getChapterReview = createAsyncThunk(
  "quiz/getChapterReview",
  async ({ reviewUrl }, { rejectWithValue, getState }) => {
    try {
      const token = getToken(getState);

      const response = await axios.get(`${baseurl}${reviewUrl}`, {
        headers: getHeaders(token),
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(handleError(error));
    }
  }
);
